import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

import {
  COMMUNITY_SIDEBAR_INDICATOR_LEFT,
  sidebarMenuListItemHighlight,
} from 'styles/sidebarMenuListItemHighlight';

export const StyledMenuItemBlock = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  letter-spacing: 1px;
  padding: 10px 15px 10px 16px;
  border-radius: 6px;
`;
export const StyledMenuItemLinkBlock = styled(NavLink)`
  flex-grow: 1;
  display: flex;
  text-decoration: none;
  align-items: center;
  gap: 10px;
  letter-spacing: 1px;
  padding: 10px 15px 10px 16px;
  border-radius: 6px;
  ${({ menuBlockStyles }) => menuBlockStyles}
  ${sidebarMenuListItemHighlight({
    indicatorLeft: COMMUNITY_SIDEBAR_INDICATOR_LEFT,
  })}

  &.active,
  &:hover {
    & > span {
      color: ${({ theme }) => theme.color.brightTurquoise};
    }
    & > div {
      & > svg {
        fill: ${({ theme }) => theme.color.brightTurquoise};
        path {
          fill: ${({ theme }) => theme.color.brightTurquoise};
          stroke: ${({ theme }) => theme.color.brightTurquoise};
        }
        circle {
          stroke: ${({ theme }) => theme.color.brightTurquoise};
        }
      }
    }
  }
`;

export const StyledIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 12px;
    height: 12px;
    ${({ iconStyles }) => iconStyles};
  }
`;

export const StyledRightIcon = styled.div`
  position: absolute;
  right: ${({ rightIconRight }) => rightIconRight || '8px'};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 900000;
  > div {
    width: 31px;
    height: 31px;
    transition: all 0.2s linear;
    :hover {
      scale: 1.2;
    }
  }
`;

export const CountWrapper = styled.span`
  position: absolute;
  border-radius: 99999px;
  top: -3px;
  right: -3px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.color.white} !important;
`;

export const StyledTitle = styled.span`
  font-size: 13px;
  text-transform: uppercase;
  line-height: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.baliHai};
  text-align: left;
  text-decoration: none;
  letter-spacing: 1px;
  display: inline-block;
  position: relative;
`;
